<textarea #textAreaElement
          [attr.id]="inputElemId"
          [attr.name]="inputElemName"
          [maxLength]="maxLength"
          [placeholder]="placeholder"
          [attr.required]="required"
          [(ngModel)]="fieldModel.value"
          [class.error]="fieldModel.valid === false"
          (keydown)="onInputFieldKeyDown($event)"
          (keyup)="onInputFieldKeyUp()"
          (blur)="onInputFieldBlur($event)"></textarea>

<!-- Achtung, wegen CSS-Selektoren, muss dieses Element direkt nach dem Input kommen! Nicht verschieben. -->
@if (fieldModel.valid === false) {
    <div
        class="errorMessage"
        [innerHTML]="fieldModel.errorMsg"></div>
}

@if (maxLength) {
    <div class="textarea-counter">{{ fieldModel.value.length }} von {{ maxLength }} Zeichen</div>
}
